import React from "react"
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { navActionCreators } from '../../stores/lis-nav-store';
import moment from 'moment-timezone';

class Footer extends React.Component {
    render() {
        return (
            <div className={this.props.location.pathname === "/" || this.props.location.pathname.includes("/home") ? "footer-wrapper home" : "footer-wrapper"} >
                <div className="footer">
                    <div>
                        <ul>
                            <li><Link to="/home">LIS Home</Link></li>
                            <li><a href="mailto:LIS@dlas.virginia.gov">Website Feedback</a></li>
                            <li>{this.props.login && this.props.login.userClaims.roles.find(x => x === "Admin"/* "APIDocumentation" */) ? <a href="/admin-developers">For Developers</a> : <a href="/developers">For Developers</a>}</li>
                            <li><Link to="/privacy">Privacy Policy</Link></li>
                            <li><Link to="/data-files">Data Files</Link></li>
                        </ul>
                    </div>
                    <div>
                        <span>{"© Copyright Commonwealth of Virginia " + moment().tz('America/New_York').format("YYYY") + ". All rights reserved. Site developed by the "}<a href="http://dlas.virginia.gov/">Division of Legislative Automated Systems (DLAS)</a></span>
                    </div>
                </div>
            </div>
        )
    }
}

const FooterWrapper = connect(
    (state) => {
        const { nav, login } = state;
        return {
            nav,
            login
        }
    },
    (dispatch) => {
        return {
            actions: bindActionCreators(Object.assign({}, navActionCreators), dispatch)
        }
    }
)(Footer)

export default withRouter(FooterWrapper)